import styled from "styled-components";

export const Styles = styled.section`
  body,
  a,
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  ul,
  li,
  ol,
 div,
 span {
  
  font-family: "GESSTWO" !important;
  
}
  min-height: 100vh;
  padding: 120px 16px 80px;
  background: radial-gradient(
      circle at top,
      rgba(21, 96, 87, 0.35),
      transparent 60%
    ),
    linear-gradient(140deg, var(--main-color-darker) 30%, #041b16 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #f7fbff;
  position: relative;
  overflow: hidden;
  
  

  &::before,
  &::after {
    content: "";
    position: absolute;
    border-radius: 50%;
    filter: blur(90px);
    opacity: 0.6;
  }

  &::before {
    width: 320px;
    height: 320px;
    background: rgba(201, 173, 110, 0.3);
    top: -120px;
    right: 15%;
  }

  &::after {
    width: 260px;
    height: 260px;
    background: rgba(21, 96, 87, 0.3);
    bottom: -80px;
    left: 12%;
  }

  .scanner-card {
    width: min(500px, 100%);
    background: rgba(1, 51, 46, 0.92);
    border-radius: 28px;
    padding: 36px 32px;
    box-shadow: 0 30px 70px rgba(0, 0, 0, 0.45);
    border: 1px solid rgba(201, 173, 110, 0.18);
    backdrop-filter: blur(16px);
    position: relative;
    z-index: 1;
    margin-top: 3rem;
  }

  .hero-copy h3 {
    margin: 0;
    font-size: 1.5;
  }

  .subtext {
    margin-top: 10px;
    color: rgba(255, 255, 255, 0.7);
    font-size: 0.95rem;
  }

  .scan-trigger {
    margin-top: 28px;
    text-align: center;
  }

  .scan-button {
    width: 100%;
    border: none;
    border-radius: 999px;
    padding: 14px 26px;
    font-size: 1rem;
    font-weight: 600;
    background: linear-gradient(
      135deg,
      var(--secondary-color),
      rgba(21, 96, 87, 0.95)
    );
    color: #fff;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
  }

  .scan-button:not(:disabled):hover {
    transform: translateY(-1px);
    box-shadow: 0 12px 32px rgba(201, 173, 110, 0.35);
  }

  .scan-button:disabled {
    cursor: not-allowed;
    opacity: 0.6;
    box-shadow: none;
    transform: none;
  }

  .scan-trigger span {
    display: block;
    margin-top: 12px;
    font-size: 0.85rem;
    color: rgba(248, 236, 214, 0.7);
  }

  .qr-wrapper {
    margin-top: 26px;
    border-radius: 20px;
    padding: 18px;
    background: rgba(4, 12, 23, 0.95);
    border: 1px solid rgba(201, 173, 110, 0.2);
  }

  .result-pill {
    margin-top: 28px;
    padding: 16px 20px;
    border-radius: 18px;
    background: rgba(21, 96, 87, 0.35);
    border: 1px dashed rgba(201, 173, 110, 0.45);
  }

  .result-pill span {
    text-transform: uppercase;
    font-size: 0.78rem;
    letter-spacing: 0.08em;
    color: rgba(248, 236, 214, 0.75);
  }

  .result-pill p {
    margin: 6px 0 0;
    font-size: 1rem;
    word-break: break-word;
  }

  .status-message {
    margin-top: 18px;
    padding: 12px 14px;
    border-radius: 12px;
    font-size: 0.95rem;
    background: rgba(21, 96, 87, 0.15);
  }

  .status-message.info {
    color: #d5f6ee;
  }

  .status-message.success {
    color: #d7f2c6;
    background: rgba(201, 173, 110, 0.12);
  }

  .status-message.error {
    color: #f7c0c0;
    background: rgba(255, 115, 116, 0.12);
  }

  .manual-form {
    margin-top: 34px;
  }

  .manual-form label {
    font-size: 0.95rem;
    font-weight: 600;
  }

  .input-row {
    margin-top: 14px;
    display: flex;
    gap: 14px;
  }

  .manual-form input {
    flex: 1;
    border-radius: 16px;
    border: 1px solid rgba(201, 173, 110, 0.25);
    padding: 12px 16px;
    background: rgba(1, 42, 37, 0.9);
    color: #fff;
    font-size: 0.95rem;
    outline: none;
    transition: border 0.2s ease, box-shadow 0.2s ease;
  }

  .manual-form input:focus {
    border-color: var(--secondary-color);
    box-shadow: 0 0 0 2px rgba(201, 173, 110, 0.3);
  }

  .manual-form button {
    border: none;
    border-radius: 16px;
    padding: 12px 22px;
    background: linear-gradient(
      135deg,
      var(--secondary-color),
      rgba(21, 96, 87, 0.95)
    );
    font-weight: 600;
    color: #fff;
    cursor: pointer;
    transition: transform 0.2s ease, opacity 0.2s ease;
  }

  .manual-form button:not(:disabled):hover {
    transform: translateY(-1px);
  }

  .manual-form button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .spinner-overlay,
  .modal-overlay {
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(3, 18, 16, 0.88);
    z-index: 10;
    padding: 20px;
    text-align: center;
  }

  .spinner-overlay {
    flex-direction: column;
    gap: 14px;
  }

  .spinner {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 4px solid rgba(255, 255, 255, 0.15);
    border-top-color: var(--secondary-color);
    animation: spin 0.9s linear infinite;
  }

  .spinner-overlay p {
    margin: 0;
    font-weight: 500;
    color: #d7f7ff;
  }

  .modal-content {
    background: rgba(1, 42, 37, 0.96);
    border-radius: 22px;
    padding: 34px 32px;
    border: 1px solid rgba(201, 173, 110, 0.25);
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.55);
    max-width: 360px;
    width: 100%;
  }

  .modal-content h3 {
    margin: 0 0 12px;
    font-size: 1.5rem;
  }

  .modal-content p {
    margin: 0 0 22px;
    color: rgba(247, 251, 255, 0.85);
    line-height: 1.4;
  }

  .modal-content button {
    width: 100%;
    border: none;
    border-radius: 14px;
    padding: 12px 0;
    font-weight: 600;
    background: linear-gradient(
      135deg,
      var(--secondary-color),
      rgba(21, 96, 87, 0.9)
    );
    color: #041611;
    cursor: pointer;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  @media (max-width: 768px) {
    .scanner-card {
      padding: 28px 24px;
    }

    .input-row {
      flex-direction: column;
    }

    .manual-form button {
      width: 100%;
    }
  }
`;
